import React, { useEffect, useState, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { useTranslation } from "react-i18next";
import styles from "./Bitiruvchilar.module.css";
import activityStyles from "./activityCards.module.css";
import classes from "./Activities.module.css";
import { testUrl } from "../BaseData";
import Pagination from "@mui/material/Pagination";

const ALUMNI_PER_PAGE = 6;

const Bitiruvchilar = () => {
    const navigate = useNavigate();
    const { t, i18n } = useTranslation();

    // Activities state
    const [activitiesLoading, setActivitiesLoading] = useState(true);
    const [activities, setActivities] = useState([]);
    const [pageApi, setPageApi] = useState(1);
    const activityItemsPerPage = 9;

    // Alumni state
    const [alumniLoading, setAlumniLoading] = useState(true);
    const [alumni, setAlumni] = useState([]);
    const [searchQuery, setSearchQuery] = useState("");
    const [alumniPage, setAlumniPage] = useState(1);

    // Fetch activities
    useEffect(() => {
        setActivitiesLoading(true);
        axios.get(testUrl + "/api/activitiestype/")
            .then((res) => {
                const types = res.data;
                const targetType = types.find(type =>
                    (type.name_uz && type.name_uz.toLowerCase().includes("bitiruvchi")) ||
                    (type.name_ru && type.name_ru.toLowerCase().includes("bitiruvchi")) ||
                    (type.name_en && type.name_en.toLowerCase().includes("bitiruvchi")) ||
                    type.name_uz === "Bizning bitiruvchilar"
                );
                const shortName = targetType && targetType.short_name ? targetType.short_name : "bizning-bitiruvchilar";
                return axios.get(testUrl + `/api/activities/${shortName}/`);
            })
            .then((response) => {
                if (response && response.data) {
                    setActivities(response.data);
                }
            })
            .catch((err) => console.error("Error fetching activities:", err))
            .finally(() => setActivitiesLoading(false));
    }, [i18n.language]);

    // Fetch alumni
    useEffect(() => {
        setAlumniLoading(true);
        axios.get(testUrl + "/api/alumni/")
            .then((res) => {
                const data = Array.isArray(res.data) ? res.data : (res.data.results || []);
                setAlumni(data);
            })
            .catch((err) => console.error("Error fetching alumni:", err))
            .finally(() => setAlumniLoading(false));
    }, [i18n.language]);

    // Filter alumni
    const filteredAlumni = useMemo(() => {
        let result = alumni;
        if (searchQuery.trim()) {
            const q = searchQuery.toLowerCase();
            result = result.filter(a =>
                (a.full_name && a.full_name.toLowerCase().includes(q)) ||
                (a.name_uz && a.name_uz.toLowerCase().includes(q)) ||
                (a.surname_uz && a.surname_uz.toLowerCase().includes(q)) ||
                (a.faculty && a.faculty.toLowerCase().includes(q)) ||
                (a.education_field && a.education_field.toLowerCase().includes(q)) ||
                (a.workplace && a.workplace.toLowerCase().includes(q)) ||
                (a.address && a.address.toLowerCase().includes(q))
            );
        }
        return result;
    }, [alumni, searchQuery]);

    useEffect(() => { setAlumniPage(1); }, [searchQuery]);

    const totalAlumniPages = Math.ceil(filteredAlumni.length / ALUMNI_PER_PAGE);
    const paginatedAlumni = filteredAlumni.slice(
        (alumniPage - 1) * ALUMNI_PER_PAGE,
        alumniPage * ALUMNI_PER_PAGE
    );

    // Activities pagination
    const currentActivities = activities.slice(
        (pageApi - 1) * activityItemsPerPage,
        pageApi * activityItemsPerPage
    );

    const getDisplayName = (a) => {
        if (a.full_name) return a.full_name;
        return `${a.surname_uz || ''} ${a.name_uz || ''}`.trim() || "Noma'lum";
    };

    const formatDate = (dateStr) => {
        if (!dateStr) return null;
        // birth_date is a "YYYY-MM-DD" string; read the year directly to avoid
        // new Date() UTC/local timezone shifts on Jan-1 dates.
        const match = String(dateStr).match(/(\d{4})/);
        return match ? match[1] : dateStr;
    };

    return (
        <div className={styles.pageWrapper}>
            {/* ===== BITIRUVCHILARIMIZ SECTION ===== */}
            <section className={styles.alumniSection}>
                {/* Section header */}
                <div className={styles.sectionHeader}>
                    <div className={styles.sectionHeaderLeft}>
                        <h1 className={styles.sectionTitle}>BITIRUVCHILARIMIZ</h1>
                    </div>
                    <div className={styles.sectionHeaderRight}>
                        <div className={styles.searchWrapper}>
                            <span className={styles.searchIcon}>🔍</span>
                            <input
                                type="text"
                                className={styles.searchInput}
                                placeholder={t("Qidirish...")}
                                value={searchQuery}
                                onChange={(e) => setSearchQuery(e.target.value)}
                            />
                        </div>
                    </div>
                </div>

                {/* Alumni cards grid */}
                {alumniLoading ? (
                    <div className={styles.loadingState}>
                        <div className={styles.spinner}></div>
                        {t("Yuklanmoqda...")}
                    </div>
                ) : paginatedAlumni.length > 0 ? (
                    <>
                        <div className={styles.alumniGrid}>
                            {paginatedAlumni.map((item) => (
                                <div key={item.id} className={styles.alumniCard}>
                                    {/* Decorative navy corners */}
                                    <span className={styles.cornerTop} aria-hidden="true"></span>
                                    <span className={styles.cornerBottom} aria-hidden="true"></span>

                                    <div className={styles.cardBody}>
                                        {/* Photo + name pill */}
                                        <div className={styles.cardPhotoSection}>
                                            <div className={styles.cardPhotoFrame}>
                                                {item.image ? (
                                                    <img src={item.image} alt={getDisplayName(item)} className={styles.cardPhoto} />
                                                ) : (
                                                    <div className={styles.cardPhotoPlaceholder}>👤</div>
                                                )}
                                            </div>
                                            <div className={styles.cardPhotoName}>
                                                {getDisplayName(item)}
                                            </div>
                                        </div>

                                        {/* Info */}
                                        <div className={styles.cardInfoSection}>
                                            <p className={styles.infoName}>{getDisplayName(item)}</p>

                                            {(item.address || item.birth_date) && (
                                                <p className={styles.infoText}>
                                                    {item.address}
                                                    {item.address && item.birth_date && <br />}
                                                    {item.birth_date && <>{formatDate(item.birth_date)} yil tug'ilgan.</>}
                                                </p>
                                            )}

                                            {(item.graduation_year || item.faculty || item.education_field) && (
                                                <p className={styles.infoText}>
                                                    {[
                                                        item.graduation_year && `${item.graduation_year} yil`,
                                                        item.faculty && `${item.faculty} fakultetining`,
                                                    ].filter(Boolean).join(' ')}
                                                    {item.education_field ? (
                                                        <>
                                                            {(item.graduation_year || item.faculty) && <br />}
                                                            <span className={styles.infoHighlight}>{item.education_field}</span>
                                                            <br />
                                                            ta'lim yo'nalishini tamomlagan.
                                                        </>
                                                    ) : (
                                                        <> ta'lim yo'nalishini tamomlagan.</>
                                                    )}
                                                </p>
                                            )}

                                            {(item.workplace || item.position) && (
                                                <p className={styles.infoText}>
                                                    {item.workplace && <>Hozirgi vaqtda {item.workplace}</>}
                                                    {item.position && (
                                                        <>{item.workplace ? <br /> : 'Hozirgi vaqtda '}{item.position} lavozimida ishlab kelmoqda.</>
                                                    )}
                                                </p>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>

                        {totalAlumniPages > 1 && (
                            <div style={{ display: 'flex', justifyContent: 'center', margin: '30px 0' }}>
                                <Pagination
                                    onChange={(e, value) => setAlumniPage(value)}
                                    count={totalAlumniPages}
                                    page={alumniPage}
                                    variant="outlined"
                                    shape="rounded"
                                />
                            </div>
                        )}
                    </>
                ) : (
                    <div className={styles.emptyState}>
                        <div className={styles.emptyStateIcon}>🎓</div>
                        <p className={styles.emptyStateText}>Bitiruvchilar topilmadi</p>
                        <p className={styles.emptyStateSubText}>
                            Ma'lumotlar admin paneldan Excel orqali yuklanadi
                        </p>
                    </div>
                )}
            </section>

            {/* ===== FAOLIYAT SECTION ===== */}
            <section className={styles.activitiesSection}>
                <div data-aos="fade-up" className={classes["container"]}>
                    <h1 className={classes["page-title"]}>{t("Faoliyat")}</h1>
                    {activitiesLoading ? (
                        <div className={styles.loadingState}>
                            <div className={styles.spinner}></div>
                            {t("Yuklanmoqda...")}
                        </div>
                    ) : (
                        <>
                            <div className={activityStyles.facultyGrid}>
                                {currentActivities.filter(Boolean).map((item) => (
                                    <div key={item.id} className={activityStyles.activityCard}
                                        onClick={() => navigate(`/activity/${item.id}`)}>
                                        <img src={item.image} alt=" " className={activityStyles.activityImage} />
                                        <div className={activityStyles.activityInfo}>
                                            <h3>{item[`name_${i18n.language}`] || item.name_uz}</h3>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            {activities.length > activityItemsPerPage && (
                                <div style={{ display: 'flex', justifyContent: 'center', margin: '24px 0' }}>
                                    <Pagination
                                        onChange={(e, value) => setPageApi(value)}
                                        count={Math.ceil(activities.length / activityItemsPerPage)}
                                        page={pageApi}
                                        variant="outlined"
                                        shape="rounded"
                                    />
                                </div>
                            )}
                        </>
                    )}
                </div>
            </section>
        </div>
    );
};

export default Bitiruvchilar;
